/* eslint-disable camelcase */
import React from 'react';

import ItemQuestionPresentation from './ItemQuestionpresentation';

export default class ItemQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showContent: false,
        };
    }

    handleShowContent({ newValue }) {
        const { question, handleActiveId } = this.props;
        this.setState({ showContent: newValue });

        if (handleActiveId && newValue) {
            handleActiveId(question.id);
        }
    }

    render() {
        const { showContent } = this.state;
        const {
            question,
            correct_question_id,
            gotoManageQuestion,
            handleConfirmDisable,
            handlePortalDisable,
            handlePortalRemove,
            handleConfirmRemove,
            showModalConfirmDisable,
            showModalConfirmRemove,
            activeId,
            gotoDuplicateQuestion,
        } = this.props;

        return (
            <ItemQuestionPresentation
                question={question}
                showContent={showContent && activeId === question.id}
                handleShowContent={this.handleShowContent.bind(this)}
                correct_question_id={correct_question_id}
                gotoManageQuestion={gotoManageQuestion}
                handleConfirmDisable={handleConfirmDisable}
                handlePortalDisable={handlePortalDisable}
                handlePortalRemove={handlePortalRemove}
                handleConfirmRemove={handleConfirmRemove}
                showModalConfirmDisable={showModalConfirmDisable}
                showModalConfirmRemove={showModalConfirmRemove}
                gotoDuplicateQuestion={gotoDuplicateQuestion}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions-database/components/ItemQuestion/index.js